<mat-dialog-content>
    <mat-icon class="warning" color="warn">error</mat-icon>
    <h1>Megerősítés</h1>
    @if (data.type == 'unattended') {
    <table>
        <tr>
            <th>Mező</th>
            <th>Érték</th>
        </tr>
        <tr>
            <td>Fizetési határidő</td>
            <td>{{data.paymentRequest.validityDate}}</td>
        </tr>
        <tr>
            <td>Lejárati idő</td>
            <td>{{data.paymentRequest.deadline}}</td>
        </tr>
        <tr>
            <td>Kedvezményezett számlaszáma</td>
            <td>{{data.paymentRequest.payee.accountNumber}}
            </td>
        </tr>
        <tr>
            <td>Kedvezményezett neve</td>
            <td>{{data.paymentRequest.payee.name}}
            </td>
        </tr>
        <tr>
            <td>Fizető fél számlaszáma</td>
            <td>{{data.paymentRequest.payer.accountNumber}}</td>
        </tr>
        <tr>
            <td>Fizető fél neve</td>
            <td>{{data.paymentRequest.payer.name}}</td>
        </tr>
        <tr>
            <td>Összeg</td>
            <td>{{data.paymentRequest.amount}}</td>
        </tr>
        <tr>
            <td>Összeg módosítható</td>
            <td>{{data.paymentRequest.amountModifiable ? 'Igen' : 'Nem'}}</td>
        </tr>
        <tr>
            <td>Közlemény</td>
            <td>{{data.paymentRequest.comment}}</td>
        </tr>
    </table>
    } @else {
    <table>
        <tr>
            <th>Mező</th>
            <th>Érték</th>
        </tr>
        <tr>
            <td>Fizetési határidő</td>
            <td>{{data.paymentRequest.validityDate}}</td>
        </tr>
        <tr>
            <td>Lejárati idő</td>
            <td>{{data.paymentRequest.deadline}}</td>
        </tr>
        <tr>
            <td>Kedvezményezett számlaszáma</td>
            <td>{{data.paymentRequest.payee.accountNumber}}
            </td>
        </tr>
        <tr>
            <td>Kedvezményezett neve</td>
            <td>{{data.paymentRequest.payee.name}}
            </td>
        </tr>
        <tr>
            <td>Fizető fél számlaszáma</td>
            <td>{{data.paymentRequest.payer.accountNumber}}</td>
        </tr>
        <tr>
            <td>Fizető fél neve</td>
            <td>{{data.paymentRequest.payer.name}}</td>
        </tr>
        <tr>
            <td>Fizető fél e-mail címe</td>
            <td>{{data.paymentRequest.payer.emailAddress}}</td>
        </tr>
        <tr>
            <td>Összeg</td>
            <td>{{data.paymentRequest.amount}}</td>
        </tr>
        <tr>
            <td>Összeg módosítható</td>
            <td>{{data.paymentRequest.amountModifiable ? 'Igen' : 'Nem'}}</td>
        </tr>
        <tr>
            <td>Közelmény</td>
            <td>{{data.paymentRequest.comment}}</td>
        </tr>
        <tr>
            <td>Közlemény módosítható</td>
            <td>{{data.paymentRequest.commentModifiable ? 'Igen' : 'Nem'}}</td>
        </tr>
    </table>
    }
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-flat-button color="primary" mat-dialog-close cdkFocusInitial>VISSZA</button>
    <button mat-flat-button color="warn" (click)="onYesClick()">MEGERŐSÍTÉS</button>
</mat-dialog-actions>